<template>
    <app-layout :title="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation">

        <div class="py-6 px-4 sm:px-6 md:px-8">
            <div class="md:grid md:grid-cols-3 md:gap-6">

                <div class="mt-0 md:col-span-3">
                    <form @submit.prevent="send" autocomplete="off" action="#" method="POST">
                        <div class="shadow sm:rounded-md sm:overflow-hidden">
                            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">

                                <div class="flex items-center">
                                    <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                        Základní údaje
                                    </h4>
                                    <div class="flex-1 border-t-2 border-gray-200"></div>
                                </div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6 sm:col-span-6">
                                        <label for="sender" class="block text-sm font-medium text-gray-700">Odesílatel</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSender" required type="text" name="sender" id="sender" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6 sm:col-span-6">
                                        <label for="recipient" class="block text-sm font-medium text-gray-700">Adresát</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmRecipient" required type="text" name="recipient" id="recipient" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6 sm:col-span-6">
                                        <label for="subject" class="block text-sm font-medium text-gray-700">Předmět</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation" required type="text" name="subject" id="subject" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>


                                <div>
                                    <label class="block text-sm font-medium text-gray-700">
                                        Přilohy
                                    </label>
                                    <dd class="mt-1 text-sm text-gray-900">
                                        <ul class="border border-gray-200 rounded-md divide-y divide-gray-200">
                                            <li v-for="attachment in messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmFiles.dmFile" class="pl-3 pr-4 py-3 flex items-center justify-between text-sm hover:bg-gray-50">
                                                <a target="_blank" :href="route('downloadAttachment', {msgId:messageId, num: attachment.fileNum})" class="w-0 flex-1 flex items-center">
                                                    <!-- Heroicon name: paper-clip -->
                                                    <svg class="shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd" />
                                                    </svg>
                                                    <span class="ml-2 flex-1 w-0 truncate">
                                                      {{ attachment.dmFileDescr }}
                                                    </span>
                                                </a>
                                                <div class="ml-4 shrink-0">
                                                    <a :download="attachment.dmFileDescr" :href="route('downloadAttachment', {msgId: messageId, num: attachment.fileNum})" class="font-medium text-blue-600 hover:text-blue-500">
                                                        Stáhnout
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </dd>
                                </div>



                                <div v-if="showMoreFields" class="flex items-center">
                                    <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                        Pomocné údaje
                                    </h4>
                                    <div class="flex-1 border-t-2 border-gray-200"></div>
                                </div>
                                <div v-if="showMoreFields">
                                    <label for="to_hands" class="block text-sm font-medium text-gray-700">K rukám</label>
                                    <div class="mt-1">
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmToHands" type="text" name="to_hands" id="to_hands" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>

                                <div v-if="showMoreFields" class="flex items-center">
                                    <button type="button" :class="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmPersonalDelivery === 'true' ? 'bg-indigo-600' : 'bg-gray-200' " class="relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <span class="sr-only">Use setting</span>
                                        <span aria-hidden="true" :class="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmPersonalDelivery === 'true' ? 'translate-x-5' : 'translate-x-0' " class="translate-x-0 inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                    </button>
                                    <span class="ml-3">
                                      <span class="text-sm font-medium text-gray-900">Zpráva typu "do vlastních rukou"</span>
                                    </span>
                                </div>

                                <!--//todo zjistit pusblish identity rozdil here-->



                                <div v-if="showMoreFields" class="flex items-center">
                                    <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                        Zmocnění (zákon, paragraf...)
                                    </h4>
                                    <div class="flex-1 border-t-2 border-gray-200"></div>
                                </div>

                                <div v-if="showMoreFields" class="grid grid-cols-6 gap-6">
                                    <div class="col-span-1">
                                        <label for="law_num" class="sr-only">Číslo</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmLegalTitleLaw" type="text" name="law_num" id="law_num" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                    <div class="col-span-1">
                                        <input disabled type="text" class="disabled:opacity-100 border-none block w-full sm:text-sm rounded-md" placeholder="/" value="/">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="law_year" class="sr-only">Rok</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmLegalTitleYear" type="text" name="law_year" id="law_year" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="law_section" class="sr-only">Paragraf</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmLegalTitleSect" type="text" name="law_section" id="law_section" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="law_paragraph" class="sr-only">Odstravec</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmLegalTitlePar" type="text" name="law_paragraph" id="law_paragraph" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                    <div class="col-span-1">
                                        <label for="law_point" class="sr-only">Písmeno</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmLegalTitlePoint" type="text" name="law_point" id="law_point" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>



                                <div v-if="showMoreFields" class="flex items-center">
                                    <h4 class="shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-indigo-600">
                                        Jednací a spisové značky
                                    </h4>
                                    <div class="flex-1 border-t-2 border-gray-200"></div>
                                </div>


                                <div v-if="showMoreFields" class="grid grid-cols-6 gap-6">
                                    <div class="col-span-3">
                                        <label for="sedner_ref" class="block text-sm font-medium text-gray-700">Č. jednací odesílatele</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSenderRefNumber" required type="text" name="sender_ref" id="sedner_ref" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                    <div class="col-span-3">
                                        <label for="sedner_ident" class="block text-sm font-medium text-gray-700">Spisová značka odesílatele</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSenderIdent" required type="text" name="sender_ident" id="sedner_ident" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>


                                <div v-if="showMoreFields" class="grid grid-cols-6 gap-6">
                                    <div class="col-span-3">
                                        <label for="recipient_ref" class="block text-sm font-medium text-gray-700">Č. jednací příjemce</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmRecipientRefNumber" required type="text" name="sender_ref" id="recipient_ref" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                    <div class="col-span-3">
                                        <label for="recipient_ident" class="block text-sm font-medium text-gray-700">Spisová značka příjemce</label>
                                        <input disabled v-model="messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmRecipientIdent" required type="text" name="sender_ident" id="recipient_ident" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                    </div>
                                </div>



                            </div>
                            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                <div class="inline float-left items-center">
                                    <a v-if="!showMoreFields" @click="showMoreFields = true" href="#" class="text-left pr-4 text-sm font-semibold text-indigo-600">
                                        Další možnosti (k rukám, zmocenění, jednací a spisové značky...)
                                    </a>
                                </div>

                                <jet-secondary-button @click.native="forward" type="button">
                                    Přeposlat
                                </jet-secondary-button>
                                <jet-button class="ml-2" @click.native="reply" type="button">
                                    Odpovědět
                                </jet-button>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Input from "@/Jetstream/Input";
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetButton from '@/Jetstream/Button'

export default {
    name: "ViewMessage",
    components: {
        Input,
        AppLayout,
        JetButton,
        JetSecondaryButton},

    data() {
        return {
            messageId: this.$page.props.messageId,
            messageData: this.$page.props.messageData,

            showMoreFields: false,
        }
    },
    methods: {
        reply(){
            let startsWithRE = this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation.substring(0, 3) === 'RE:';

            let data = {
                recipient_id: this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dbIDSender,
                recipient_name: this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSender,
                recipient_type: this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSenderType,
                recipient_address: this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSenderAddress,

                sender_ref: this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmRecipientRefNumber,
                sender_ident: this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmRecipientIdent,
                recipient_ref: this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSenderRefNumber,
                recipient_ident: this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmSenderIdent,

                subject: startsWithRE ? this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation
                                      :'RE: ' + this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation,
            }

            this.$inertia.visit(route('reply', data))
        },
        forward(){
            let startsWithFWD = this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation.substring(0, 4) === 'FWD:';
            this.$inertia.visit(route('forward', {
                id: this.messageId,
                subject: startsWithFWD ? this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation
                                       : 'FWD: ' + this.messageData.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation,
            }))
        }
    }
}

</script>

<style scoped>

</style>
